import React from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import { NAVIGATION_ROUTES } from "../constant";
import LoginPage from "../pages/SignUp"; 
import OtpScreen from "../pages/OtpScreen";
import { logout, useTokenStore } from "../storage/tokenState";
import { _isEmpty } from "../utils/referralLodash";
import ProtectedRoute from "../components/ProtectedRoute/ProtectedRoute";
import TermsAndConditions from "../pages/Terms-And-Conditions";
import Subscription from "../pages/Subscription";
import Subscribed from "../pages/Subscribed";
import AppDownload from "../pages/AppDownload";
import SubscriptionPayment from "../pages/SubscriptionPayment";
import PaymentFailed from "../pages/PaymentFailed";
import PaymentProcessing from "../pages/PaymentProcessing";
import PaymentWaiting from "../pages/PaymentWaiting";

// Sign-ups directory imports
import SignUpsSubscription from "../pages/trial";
import SignUpsSignUp from "../pages/trial/SignUp";
import SignUpsOtpScreen from "../pages/trial/OtpScreen";
import SignUpsSubscribed from "../pages/trial/Subscribed";
import SignUpsSubscriptionPayment from "../pages/trial/SubscriptionPayment";
import SignUpsPaymentFailed from "../pages/trial/PaymentFailed";
import SignUpsPaymentProcessing from "../pages/trial/PaymentProcessing";
import SignUpsPaymentWaiting from "../pages/trial/PaymentWaiting";
import SignUpsPayoutHistory from "../pages/trial/PayoutHistory";
import SignUpsPlansDemo from "../pages/trial/PlansDemo";

import { useAutoLogout } from "../hooks/useAutoLogout";
import QrCode from "../pages/QrCode";
import SessionExpire from "../pages/SessionExpire";

const AppRoutes: React.FC = () => {
  // Enable auto-logout on token expiry and inactivity (5 minutes default)
  useAutoLogout(5 * 60 * 1000); // 5 minutes inactivity timeout
  //useAutoLogout(9000);
  // const { isLoggedIn } = useAuth();
  const {
    token: userToken,
    splashConfig: { expiry, backgroundColor, video },
    language,
  } = useTokenStore();
  const location = useLocation();
  const pathName = location.pathname;
  const className = pathName
    .replace(/^\//, "")
    .replace(/\//g, "-")
    .replace(/-$/, "");


  return (
    <div className={`${className}-page`} >
     
      <Routes>
      <Route path={NAVIGATION_ROUTES.REFERRAL_HOME} element={<Subscription />} />
      <Route path={NAVIGATION_ROUTES.REFERRAL_TNC} element={<TermsAndConditions />} />
      <Route path={NAVIGATION_ROUTES.REFERRAL_SUBSCRIPTION} element={<Subscription />} />
      <Route path={NAVIGATION_ROUTES.REFERRAL_SUBSCRIBED} element={<Subscribed />} />
      <Route path={NAVIGATION_ROUTES.REFERRAL_APP_DOWNLOAD} element={<AppDownload />} />
      <Route path={NAVIGATION_ROUTES.REFERRAL_SUBSCRIPTION_PAYMENT} element={<SubscriptionPayment />} />
      <Route path={NAVIGATION_ROUTES.REFERRAL_PAYMENT_FAILED} element={<PaymentFailed />} />
      <Route path="/subscriptionpayment" element={<SubscriptionPayment />} />
     {/* Allow signup/login and OTP pages to be accessible regardless of login status */}
     <Route path={NAVIGATION_ROUTES.REFERRAL_SIGNUP} element={<LoginPage />} />
     <Route path={NAVIGATION_ROUTES.REFERRAL_LOGIN} element={<LoginPage />} />
     <Route path={NAVIGATION_ROUTES.REFERRAL_OTP} element={<OtpScreen />} />
     <Route path="/OtpScreen" element={<OtpScreen />} />
     <Route path={`${NAVIGATION_ROUTES.REFERRAL_OTP}/:phoneNumber/:action`} element={<OtpScreen />} />
      <Route path="/payment-failed" element={<PaymentFailed />} />
      <Route path="/payment-processing" element={<PaymentProcessing />} />
      <Route path="/payment-waiting" element={<PaymentWaiting />} />
      
      {/* Sign-ups directory routes */}
      <Route path="/trial" element={<SignUpsSubscription />} />
      <Route path="/trial/signup" element={<SignUpsSignUp />} />
      <Route path="/trial/otp" element={<SignUpsOtpScreen />} />
      <Route path="/trial/otp/:phoneNumber/:action" element={<SignUpsOtpScreen />} />
      <Route path="/trial/subscribed" element={<SignUpsSubscribed />} />
      <Route path="/trial/subscription-payment" element={<SignUpsSubscriptionPayment />} />
      <Route path="/trial/payment-failed" element={<SignUpsPaymentFailed />} />
      <Route path="/trial/payment-processing" element={<SignUpsPaymentProcessing />} />
      <Route path="/trial/payment-waiting" element={<SignUpsPaymentWaiting />} />
      <Route path="/trial/payout-history" element={<SignUpsPayoutHistory />} />
      <Route path="/trial/plans-demo" element={<SignUpsPlansDemo />} />

      <Route path="/qr-code" element={<QrCode />} />
      <Route path={NAVIGATION_ROUTES.REFERRAL_SESSION_EXPIRE} element={<SessionExpire />} />

     { _isEmpty(userToken) ?
       <>
        <Route path={NAVIGATION_ROUTES.REFERRAL_SIGNUP} element={<LoginPage />} /> 
        {/* Route for CSS work - allows direct access without params */}
        <Route path={NAVIGATION_ROUTES.REFERRAL_OTP} element={<OtpScreen />} />
        <Route path="/OtpScreen" element={<OtpScreen />} />
        <Route path={`${NAVIGATION_ROUTES.REFERRAL_OTP}/:phoneNumber/:action`} element={<OtpScreen />} />
       </>
       :
       <>
        <Route path={NAVIGATION_ROUTES.REFERRAL_SIGNUP} element={<Navigate to={NAVIGATION_ROUTES.REFERRAL_HOME} replace />} />
        {/* Route for CSS work - allows direct access without params even when logged in */}
        <Route path={NAVIGATION_ROUTES.REFERRAL_OTP} element={<OtpScreen />} />
        <Route path="/OtpScreen" element={<OtpScreen />} />
       </>
     }

      { <Route
          path="*"
          element={<Navigate to={NAVIGATION_ROUTES.REFERRAL_HOME} replace />}
        /> }
      {/*<Route path={NAVIGATION_ROUTES.REFERRAL_HOME} element={<Navigate to={NAVIGATION_ROUTES.REFERRAL_SIGNUP} />} /> */}

      </Routes>
    </div>
  );
};

export default AppRoutes;
